var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "delete-layers-map-container" },
    [
      _c("tabs", {
        attrs: {
          activeTab: 0,
          tabs: _vm.tabs,
          "center-tabs": false,
          "tabs-styling": _vm.tabsStyling,
          "tabs-labels-styling": _vm.tabsLabelsStyling
        }
      }),
      _vm._v(" "),
      _c("management-map", {
        style: { height: "calc(100% - 50px)" },
        attrs: {
          "show-upload-geom-from-file-button": true,
          "show-center-map-button": true,
          "show-coordinates-button": true,
          "show-restart-button": true,
          "is-delete-layers": true
        },
        on: {
          "map-restart": function($event) {
            return _vm.$emit("map-restart")
          },
          "set-shape-geom": function($event) {
            return _vm.$emit("set-shape-geom", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42b1c20e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42b1c20e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Data/Delete/DeleteLayersMap.vue
// module id = null
// module chunks = 